import React, { useEffect, useState } from "react";
import { getStatusMessage } from "../../services/Miscellaneous";
import "./styles.css";
import StatusIcon from "../../assets/images/statusinfo.svg";
import CrossIcon from "../../assets/images/cross.svg";

const StatusMessage = () => {
  const [statusMessage, setStatusMessage] = useState();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    statusMessageInit();
  }, []);

  const statusMessageInit = async () => {
    try {
      const { code, result } = await getStatusMessage();
      if (result) {
        setStatusMessage({ title: result.title, message: result.message });
        console.log(result, code);
      }
    } catch (error) {
      console.error("Error fetching status message:", error);
    }
  };
  return statusMessage ? (
    <>
      <div className="status-icon-wrap">
        <img
          src={StatusIcon}
          className="cursor-pointer"
          onClick={() => setExpanded(!expanded)}
        />
      </div>
      {expanded ? (
        <div className="status-message-wrap">
          <div style={{ float: "right" }}>
            <img
              src={CrossIcon}
              className="cursor-pointer"
              onClick={() => setExpanded(false)}
            />
          </div>
          <div style={{ clear: "both" }}></div>
          <div className="triangle-left"></div>
          <div className="msg-heading-text">{statusMessage?.title}</div>
          <div className="msg-body-text">{statusMessage?.message}</div>
        </div>
      ) : (
        <></>
      )}
    </>
  ) : (
    <></>
  );
};

export default StatusMessage;
